export const setDocumentTitle = (pageTitle) => {
	return document.title = pageTitle ? `${pageTitle} - Ops Portal` : "Ops Portal";
};
